import packageJson from '../package.json'
import logo from './assets/img/logo.png'

export interface ConfigInterface {
  name: string
  env: 'development' | 'production' | 'preview' | 'localhost' | 'docker'
  logo: any
  logoMenu: any
  email: string
  phone: string
  address: string
  frontHostname: string
  frontEndUrl: string
  graphqlUri: string
  graphqlWs: string
  urlApp: string
  urlLocalPanel: string
  keycloak: {
    realm: string
    url: string
    clientId: string
  }
  version: string
  urlManager: string
  googleMapsApiKey: string
}

const configDefault: ConfigInterface = {
  name: 'PassFree',
  env: 'production',
  logo,
  logoMenu: logo,
  email: '',
  phone: '',
  address: '',
  frontHostname: '',
  frontEndUrl: '',
  graphqlUri: '',
  graphqlWs: '',
  urlApp: '',
  urlLocalPanel: '',
  keycloak: {
    realm: 'passfree',
    url: 'https://conta.passfree.com.br',
    clientId: 'admin-front',
  },
  version: packageJson.version,
  urlManager: '',
  googleMapsApiKey: 'AIzaSyCZmKQhVCcS3aM0wA2Az0YtUhVkwHUek4I',
}

const configProd: ConfigInterface = {
  ...configDefault,
  env: 'production',
  frontHostname: 'admin.passfree.com.br',
  frontEndUrl: 'https://admin.passfree.com.br',
  graphqlUri: 'https://api.passfree.com.br/graphql',
  graphqlWs: 'wss://api.passfree.com.br/graphql',
  urlApp: 'https://app.passfree.com.br',
  urlLocalPanel: 'https://local.passfree.com.br',
}

const configDev: ConfigInterface = {
  ...configDefault,
  env: 'development',
  frontHostname: 'admin.passfree.site',
  frontEndUrl: 'https://admin.passfree.site',
  graphqlUri: 'https://api.passfree.site/graphql',
  graphqlWs: 'wss://api.passfree.site/graphql',
  urlApp: 'https://app.passfree.site',
  urlLocalPanel: 'https://local.passfree.site',
  keycloak: {
    realm: 'passfree-dev',
    url: 'https://conta.passfree.site',
    clientId: 'admin-front',
  },
}

const configLocal: ConfigInterface = {
  ...configDev,
  name: 'Passfree - [LOCAL]',
  env: 'localhost',
  frontHostname: 'localhost:3000',
}

const getEnv = (): ConfigInterface => {
  const { host } = window.location

  const envs = [configProd, configDev, configLocal]

  const config = envs.find(env => env.frontHostname === host)

  if (!config) {
    // eslint-disable-next-line no-console
    console.warn('Invalid env config, using default => development')
    return configDev
  }

  return config
}

function printBannerDev() {
  // eslint-disable-next-line no-console
  console.log('PRINT BANNER DEV')

  const newDiv = document.createElement('div')
  const newContent = document.createTextNode('AMBIENTE DE TESTE')

  newDiv.style.display = 'block'
  newDiv.style.background = 'rgb(255 0 0 / 60%)'
  newDiv.style.width = '100%'
  newDiv.style.height = '19px'
  newDiv.style.textAlign = 'center'
  newDiv.style.position = 'absolute'
  newDiv.style.zIndex = '50'
  newDiv.style.fontSize = '15px'

  newDiv.appendChild(newContent)
  document.body.prepend(newDiv)

  document.title = `[DEV] ${document.title}`
}

export const Config: ConfigInterface = getEnv()

if (Config.env !== 'production') {
  printBannerDev()
}
